import axiosInstance from './AxiosInstance';

const UsersService = {
    // Get all users with pagination and filtering
    getAllUsers: async (params = {}) => {
        try {
            console.log('params', params)
            const queryParams = new URLSearchParams();
            
            // Add pagination parameters
            if (params.page) queryParams.append('page', params.page);
            if (params.limit) queryParams.append('limit', params.limit);
            
            // Add filter parameters
            if (params.search) queryParams.append('search', params.search);
            if (params.status) queryParams.append('status', params.status);
            if (params.city) queryParams.append('city', params.city);
            if (params.state) queryParams.append('state', params.state);
            if (params.country) queryParams.append('country', params.country);
            
            const queryString = queryParams.toString();
            const url = queryString ? `/user-management?${queryString}` : '/user-management';
            
            const response = await axiosInstance.get(url);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to fetch users";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    },

     getAllUsers: async (params = {}) => {
        try {
            const queryParams = new URLSearchParams();
            if (params.search) queryParams.append('search', params.search);
            const queryString = queryParams.toString();
            const url = queryString ? `/user-management/search?${queryString}` : '/user-management';
            const response = await axiosInstance.get(url);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to search users";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    },

    

    // Get user by ID
    getUserById: async (id) => {
        try {
            const response = await axiosInstance.get(`/user-management/${id}`);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to fetch user";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    },

    // Get user with roles
    getUserWithRoles: async (id) => {
        try {
            const response = await axiosInstance.get(`/user-management/${id}/with-roles`);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to fetch user with roles";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    },

    // Create new user
    createUser: async (userData) => {
        try {
            const response = await axiosInstance.post('/user-management', userData);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to create user";
            const validationErrors = error.response?.data?.errors || [];
            throw {
                message: errorMessage,
                validationErrors: validationErrors,
                status: error.response?.status
            };
        }
    },

    // Update user
    updateUser: async (id, userData) => {
        try {
            const response = await axiosInstance.put(`/user-management/${id}`, userData);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to update user";
            const validationErrors = error.response?.data?.errors || [];
            throw {
                message: errorMessage,
                validationErrors: validationErrors,
                status: error.response?.status
            };
        }
    },

    // Delete user (soft delete)
    deleteUser: async (id) => {
        try {
            const response = await axiosInstance.delete(`/user-management/${id}`);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to delete user";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    },

    // Role Management Methods

    // Assign role to user
    assignRole: async (roleData) => {
        try {
            const response = await axiosInstance.post('/user-management/assign-role', roleData);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to assign role";
            const validationErrors = error.response?.data?.errors || [];
            throw {
                message: errorMessage,
                validationErrors: validationErrors,
                status: error.response?.status
            };
        }
    },

    // Assign user to company
    assignToCompany: async (assignmentData) => {
        try {
            const response = await axiosInstance.post('/user-management/assign-to-company', assignmentData);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to assign user to company";
            const validationErrors = error.response?.data?.errors || [];
            throw {
                message: errorMessage,
                validationErrors: validationErrors,
                status: error.response?.status
            };
        }
    },

    // Get user role assignments
    getUserRoleAssignments: async (userId) => {
        try {
            const response = await axiosInstance.get(`/user-management/${userId}/role-assignments`);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to fetch role assignments";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    },

    // Get users by company
    getUsersByCompany: async (companyId, params = {}) => {
        try {
            const queryParams = new URLSearchParams();
            
            if (params.page) queryParams.append('page', params.page);
            if (params.limit) queryParams.append('limit', params.limit);
            
            const queryString = queryParams.toString();
            const url = queryString 
                ? `/user-management/company/${companyId}/users?${queryString}` 
                : `/user-management/company/${companyId}/users`;
            
            const response = await axiosInstance.get(url);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to fetch users by company";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    },

    // Update role assignment
    updateRoleAssignment: async (assignmentId, assignmentData) => {
        try {
            const response = await axiosInstance.put(`/user-management/role-assignment/${assignmentId}`, assignmentData);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to update role assignment";
            const validationErrors = error.response?.data?.errors || [];
            throw {
                message: errorMessage,
                validationErrors: validationErrors,
                status: error.response?.status
            };
        }
    },

    // Remove role assignment
    removeRoleAssignment: async (assignmentId) => {
        try {
            const response = await axiosInstance.delete(`/user-management/role-assignment/${assignmentId}`);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to remove role assignment";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    },

    // Authentication Methods (for profile management)

    // Get user profile
    getUserProfile: async () => {
        try {
            const response = await axiosInstance.get('/users/profile');
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to fetch profile";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    },

    // Update user profile
    updateUserProfile: async (profileData) => {
        try {
            // Use PUT for updating profile; ensure email and phoneNumber are included in payload
            const response = await axiosInstance.post('/users/profile', profileData);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to update profile";
            const validationErrors = error.response?.data?.errors || [];
            throw {
                message: errorMessage,
                validationErrors: validationErrors,
                status: error.response?.status
            };
        }
    },

    // Change password for current user
    changePassword: async (passwordData) => {
        try {
            const response = await axiosInstance.post('/users/profile/password', passwordData);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to change password";
            const validationErrors = error.response?.data?.errors || [];
            throw {
                message: errorMessage,
                validationErrors: validationErrors,
                status: error.response?.status
            };
        }
    },

    // Upload profile avatar (file only)
    uploadAvatar: async (file) => {
        try {
            const formData = new FormData();
            formData.append('avatar', file);
            const response = await axiosInstance.post('/users/profile/avatar', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to upload avatar";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    },

    // Login user
    loginUser: async (credentials) => {
        try {
            const response = await axiosInstance.post('/users/login', credentials);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to login";
            const validationErrors = error.response?.data?.errors || [];
            throw {
                message: errorMessage,
                validationErrors: validationErrors,
                status: error.response?.status
            };
        }
    },

    // Refresh token
    refreshToken: async (tokenData) => {
        try {
            const response = await axiosInstance.post('/users/refresh-token', tokenData);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to refresh token";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    },

    // Get users statistics
    getUsersStatistics: async (params = {}) => {
        try {
            const queryParams = new URLSearchParams();
            if (params.companyId) queryParams.append('companyId', params.companyId);
            if (params.branchId) queryParams.append('branchId', params.branchId);

            const url = `/statistics/users${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
            const response = await axiosInstance.get(url);
            
            return {
                success: response.data.success,
                data: response.data.data,
                message: response.data.message
            };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Failed to fetch users statistics',
                data: {
                    active_count: 0,
                    inactive_count: 0,
                    pending_count: 0,
                    total_count: 0
                }
            };
        }
    },

    // Get SuperAdmin and Admin users only
    getSuperAdminAndAdmins: async () => {
        try {
            const response = await axiosInstance.get('/users/superadmin-and-admins');
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Failed to fetch admins";
            throw {
                message: errorMessage,
                status: error.response?.status
            };
        }
    }
};

export default UsersService;
